import { useTranslation } from "react-i18next";
import { Form, Layout, Space, TableColumnsType, message } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { routesConfig } from "../../../../../config/routes";
import { formatDateToIsoStringHHss } from "../../../../../utils/converDate";
import { TableProps } from "antd/lib";
import PageHeader from "../../../../../components/page-header/PageHeader";
import TableData from "../../../../../components/table-data/TableData";
import {
  getCoursePlanAssignmentHistory,
} from "../../../../../service/course-plan-managment/mooc-course-plan-assignment/mooc-course-plan-assignment-api";

const AssignmentHistory = () => {
  const { t } = useTranslation();
  const imgPath = "/images/";
  const [loading, setLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [listMoocActionHistory, setListMoocActionHistory] = useState();
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const { id } = useParams();

  const listBreadcrumb = [
    {
      title: t("Kế hoạch khóa học", "Kế hoạch khóa học"),
    },
    {
      title: (
        <a
          href={`/${routesConfig.coursePlan}/${routesConfig.planningAssignment}`}
        >
          {t("Phân công lập kế hoạch", "Phân công lập kế hoạch")}
        </a>
      ),
    },
    {
      title: t("Lịch sử thao tác phân công lập kế hoạch xây dựng khóa học", "Lịch sử thao tác phân công lập kế hoạch xây dựng khóa học"),
    },
  ];

  const dataColumns: TableColumnsType<any> = [
    {
      title: t("STT", "STT"),
      key: "numericalOrder",
      width: "3%",
      render: (_: any, record, index: number) => {
        const orderNumber = (index + 1).toString().padStart(2);
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Người phân công", "Người phân công"), 
      dataIndex: "nameAssigner",
      key: "nameAssigner",
      width: "20%",
    },
    {
      title: t("Người được phân công", "Người được phân công"), 
      dataIndex: "nameAssignee",
      key: "nameAssigner",
      width: "20%",
    },
    {
      title: t("Thời gian", "Thời gian"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: "10%",
      render: (_: any, record, index: number) => {
        const dateTimeConvert = record?.createdDate
          ? formatDateToIsoStringHHss(record?.createdDate.toString())
          : null;
        const parts = dateTimeConvert ? dateTimeConvert.split(" ") : [];
        const time = parts.length > 1 ? parts[0] : null;
        const date = parts.length > 1 ? parts[1] : null;
        return (
          <Space direction="vertical">
            <span>{time}</span>
            <span>{date}</span>
          </Space>
        );
      },
    },
    {
      title: t("Nội dung phân công", "Nội dung phân công"),
      dataIndex: "actionDetail",
      key: "actionDetail",
      width: 3,
      render: (_: any, record, index: number) => {
        return (
          <span>
            {record?.nameAssigner} {t("đã phân công cho", "đã phân công cho")} {record?.nameAssignee}{" "}
            {record?.itemId === null
              ? t("chủ trì xây dựng kế hoạch", "chủ trì xây dựng kế hoạch")
              : t("phụ trách tại mục", "phụ trách tại mục") + " " + record?.itemName}
          </span>
        );
      },
    },
  ];

  const getListData = (id: number) => {
    setLoading(true);

    const data = {
      keyword: searchValue,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortField: fieldSortOrder,
      sortOrder: statusOrder,
      courseConstructionPlanId: Number(id),
    };

    getCoursePlanAssignmentHistory(data)
      .then((res) => {
        const { data } = res.data;
        setListMoocActionHistory(data.data);
        setTotalRecords(data.totalRecords);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        setLoading(false);
        message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
      });
  };

  useEffect(() => {
    getListData(Number(id));
  }, [id]);


  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  return (
    <Layout className="page-header-group course-construction">
      <Form.Provider
        onFormFinish={(formName, { values, forms }) => {
          if (formName === "create-edit-mooc-action-history-detail") {
            console.log("valuesForm", values);
          }
        }}
      >
        <div className={`page-header-group--layout`}>
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader
                title={t("Lịch sử thao tác phân công lập kế hoạch", "Lịch sử thao tác phân công lập kế hoạch")}
                listBreadcrumb={listBreadcrumb}
                arrowLeft={imgPath + "arrowLeft.svg"}
                positionItem="column"
                breadcrumb={true}
              />
            </div>
          </div>
        </div>

        <div className="tabs-heading">
          <TableData
            dataTable={listMoocActionHistory}
            dataColumns={dataColumns}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            loadingTable={loading}
            scroll={{ x: 1500, y: 600 }}
            totalRecords={totalRecords}
            handleTableChangeProps={handleTableChange}
            pagination={true}
          />
        </div>
      </Form.Provider>
    </Layout>
  );
};

export default AssignmentHistory;
